import styled from "styled-components";
import CONSTANT from "../../constants/constant";

const StyledInput = styled.input`
  width: 100%;
  min-width: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "150px" : ""};
  min-height: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "100%" : ""};
  height: 100%;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  padding: 0px 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  border-radius: 40px 0px 0px 40px;
  font-size: ${(props) =>
    props.variant === CONSTANT.VARIANT.SMALL ? "14px" : "16px"};

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.blue};
    outline: none;
  }
  @media screen and (max-width: 760px) {
    max-width: ${(props) =>
      props.variant === CONSTANT.VARIANT.SMALL ? "20%" : ""};
  }
`;

export default StyledInput;
